import React, { Fragment } from "react";
import {useQueryClient} from "react-query";
import {Icon} from "@material-ui/core";
import {useNotes} from "../../../services/notes";


const NotesCount = (props) => {
  const {tripData, classes} = props;

  const queryClient = useQueryClient();
  const noteType = tripData.recordType === "SCHEDULED" ? `SCHEDULED_FLIGHT:${tripData.airlineCode}${tripData.flightNo}` : encodeURIComponent("TRIP_LEG:FLIGHT%");
  const extraKeys = [tripData.uuid, noteType];
  const notes = useNotes({queryClient, extraKeys});

  const noteCount = notes && Array.isArray(notes.data) && notes.data.length > 0 ? notes.data.length : undefined;

  return (
    <Fragment>
      {noteCount
        ?
        noteCount > 9
          ?
            <Icon fontSize="medium">filter_9_plus</Icon>
          :
            <Icon fontSize="medium">{`filter_${noteCount}`}</Icon>
        :
          <></>
      }
    </Fragment>
  );
}

export default NotesCount;
